export var PaymentEndpoints = {
    getIntent: function () { return "/public/payments/intent"; },
    tokenise: function () { return "/public/payments/tokenise"; },
    createPaymentMethod: function () { return "/public/payments/payment-method"; },
    reportSingleChargeSuccess: function () { return "/public/payments/report-single-charge-success"; },
};
